import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import {} from "../routes/users/api/Representation";
import { nonEmpty } from "../../../swzutils";
import { userHasPermission } from "../../../swzutils/UserPermissionsUtil";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";
import { useAppSelector } from "../../../store";
import { loggedInUserSelector } from "../../../store/slice/auth";
const UserSummary = ({ user, showLink = true }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    let hasViewPermission;
    let hasEditPermission;
    switch (user?.type ?? null) {
        case 'ADMIN':
            hasViewPermission = userHasPermission(loggedInUser, ['admin:user:view']);
            hasEditPermission = userHasPermission(loggedInUser, ['admin:user:update']);
            break;
        case 'DRIVER':
            hasViewPermission = userHasPermission(loggedInUser, ['admin:driver:view']);
            hasEditPermission = userHasPermission(loggedInUser, ['admin:driver:update']);
            break;
        default:
            hasViewPermission = false;
            hasEditPermission = false;
    }
    if (!user) {
        return null;
    }
    return _jsxs(_Fragment, { children: [nonEmpty `${user.firstName} ${user.lastName}`, " ", (showLink && hasEditPermission)
                ? _jsx("a", { href: `#/app/users/edit/${user.id}`, children: _jsx(LinkOutlined, {}) }) : null] });
};
export default UserSummary;
